import { Card } from "@/components/ui/Card";
import { MOCK_TOP_TOPICS } from "@/components/mocks/fixtures";
import type { DashboardTopTopic } from "@/lib/dashboard";

interface Props {
  data?: DashboardTopTopic[];
}

export function TopTopics({ data }: Props = {}) {
  const topics = data && data.length > 0 ? data : MOCK_TOP_TOPICS;
  const max = Math.max(...topics.map((t) => t.count));

  return (
    <Card surface="base" className="p-7">
      <p className="font-mono text-[11px] uppercase tracking-[0.08em] text-[var(--color-slate-200)] mb-5">
        Top topics this week
      </p>
      <ul className="space-y-3">
        {topics.map((t, i) => {
          const pct = (t.count / max) * 100;
          return (
            <li key={t.name} className="flex items-center gap-3">
              <span className="font-mono text-[12px] text-[var(--color-slate-300)] w-5 shrink-0">
                {i + 1}.
              </span>
              <span className="text-[14px] text-[var(--color-snow)] w-44 shrink-0">
                {t.name}
              </span>
              <div className="relative flex-1 h-[6px] rounded-full bg-[var(--color-graphite-700)] overflow-hidden">
                <div
                  className="absolute inset-y-0 left-0 rounded-full bg-[var(--color-sky)]/70"
                  style={{ width: `${pct}%` }}
                />
              </div>
              <span className="font-mono text-[12px] text-[var(--color-slate-200)] w-12 text-right tabular-nums">
                {t.count}
              </span>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
